import { css } from "@emotion/css";
export const iconStyles = css({
    width: "24px",
    height: "24px",
    fill: "currentcolor",
    display: "block",
});
